import { render, staticRenderFns } from "./Sangplatta.vue?vue&type=template&id=72dd50c8&scoped=true&"
import script from "./Sangplatta.vue?vue&type=script&lang=js&"
export * from "./Sangplatta.vue?vue&type=script&lang=js&"
import style0 from "./Sangplatta.vue?vue&type=style&index=0&id=72dd50c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dd50c8",
  null
  
)

export default component.exports